import { LocaleId, TranslationDictionaryMapping } from '@i18n';
import { FeatureRegisterAnotherApplianceTranslationDictionary } from './feature-register-another-appliance-dictionary.interface';

export const translation: TranslationDictionaryMapping<FeatureRegisterAnotherApplianceTranslationDictionary> =
  {
    [LocaleId.English_GreatBritain]: {
      REGISTER_ANOTHER_APPLIANCE_TITLE:
        'Do you have other appliances to register?',
      REGISTER_ANOTHER_APPLIANCE_BUTTON: 'Register another appliance',
      REGISTER_ANOTHER_APPLIANCE_LIST: [
        'Register older appliances even without the receipt?',
        'Register appliances that you gained when buying a new house',
        'Register appliances that were given as gifts or bought second hand?',
      ],
    },
    [LocaleId.English_Ireland]: {
      REGISTER_ANOTHER_APPLIANCE_TITLE:
        'Do you have other appliances to register?',
      REGISTER_ANOTHER_APPLIANCE_BUTTON: 'Register another appliance',
      REGISTER_ANOTHER_APPLIANCE_LIST: [
        'Register older appliances even without the receipt?',
        'Register appliances that you gained when buying a new house',
        'Register appliances that were given as gifts or bought second hand?',
      ],
    },
  };
